import { createAsyncThunk } from '@reduxjs/toolkit';
import { notificationApi } from '~/apis/notification';
import { GET_LIST_NOTIFICATIONS } from '~/utils/constants/actionType';

export const getListNotifications = createAsyncThunk(GET_LIST_NOTIFICATIONS, async (_, { rejectWithValue }) => {
  try {
    const res = await notificationApi.getListNotifications();
    return res.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
